import { actionCreators as commonSourceSelectorActionCreators } from "modules/common/SourceSelector";
import { getCommonSourceItems } from "utils/helper/localStorage";
import { isEqual } from "utils/helper/common";

interface Store {
  getState: () => {
    reducers: {
      commonSourceSelector: {
        items: unknown[];
      };
    };
  };
  dispatch: (action: unknown) => void;
}

// commonSourceSelector の選択肢をローカルストレージと同期するための関数（別タブで企業種別を操作された時の対応）
// https://nikkeilabs.backlog.jp/view/B2B_NVS_FR_2018-6379
export default function setupCommonSourceSelectorSync(
  store: Store
): () => void {
  if (typeof window === "undefined") return () => {};

  const onStorage = (event: StorageEvent): void => {
    if (event.key !== "persist:root") return;

    const items = getCommonSourceItems();
    if (!Array.isArray(items)) return;

    const currentItems = store.getState().reducers.commonSourceSelector.items;
    if (isEqual(items, currentItems)) return;

    store.dispatch(commonSourceSelectorActionCreators.syncSelection(items));
  };

  window.addEventListener("storage", onStorage);

  return () => window.removeEventListener("storage", onStorage);
}
